import { render } from "./ChatListRooms.vue?vue&type=template&id=61913cd1"
import script from "./ChatListRooms.vue?vue&type=script&lang=js"
export * from "./ChatListRooms.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__